var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-center align-center"},[_vm._v(" "+_vm._s(_vm.currentTime)+" "),(_vm.currentTime != null)?_c('i',{staticClass:"fas fa-clock"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }